import React from 'react'
import Blog1 from '../images/blog/blog-1.png'
import Blog2 from '../images/blog/blog-2.png'
import Blog3 from '../images/blog/blog-3.png'
import User from '../images/blog/user-2.png'
const Blog = () => {
    const BlogData = [
        {
            id:1,
            img:Blog1,
            title:'',
            userImage:User,
            service:['Services','Design'],
            userName:'Shehzad',
            userTitle:'Frontend Devloper'
        },
        {
            id:2,
            img:Blog2,
            title:'',
            userImage:User,
            service:['Services','Design'],
            userName:'Shehzad',
            userTitle:'Frontend Devloper'
        },
        {
            id:3,
            img:Blog3,
            title:'',
            userImage:User,
            service:['Services','Design'],
            userName:'Shehzad',
            userTitle:'Frontend Devloper'
        },
    ]
  return (
    
<section id='blog' class="py-16">
    <div class="mx-auto max-w-7xl px-8 md:px-6">
        {/* <!-- heading text --> */}
        <div class="mb-5 sm:mb-10">
            <span class="font-medium text-blue-500">Our Blog</span>
            <h1 class="text-2xl font-bold text-slate-700 sm:text-3xl">From Our Latest Blog</h1>
        </div>
        {/* <!-- wrapper --> */}
        <div class="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:gap-10">
            {/* <!-- single-blog --> */}
            {
                BlogData && BlogData.map((data)=>(
                    <div class="w-full duration-200 hover:scale-95">
                        <div class="max-h-52 w-full overflow-hidden rounded-t-xl">
                            <img src={data.img} alt="blog img" class="w-full" />
                        </div>
                        <div class="rounded-b-xl px-5 pb-5 pt-3 shadow-md shadow-blue-500/10">
                            <div class="">
                                {
                                    data.service.map((ser)=>(
                                        <a href="#" class="mr-2 rounded-md bg-blue-50 px-3 py-1 text-sm text-slate-600">{ser}</a>
                                    ))
                                }
                                <a href="#" class="block pt-4 font-medium capitalize text-slate-800 hover:text-blue-500">Lorem Ipsum Dolor Sit Amet, Consectetur Adipisicing Elit.</a>
                            </div>
                            <hr class="my-4 border-slate-100" />
                            <div class="flex">
                                <img src={data.userImage} alt="user img" class="mr-3 h-10 w-10 rounded-full object-cover"/>
                                <p class="text-sm font-semibold capitalize text-slate-600">{data.userName} <span class="block text-xs text-slate-400">{data.userTitle}</span></p>
                            </div>
                        </div>
                    </div>

                ))
            }

        </div>
    </div>
</section>

  )
}

export default Blog